module.exports = __webpack_public_path__ + "static/media/polygon-icon.8b89e333.svg";